module.exports = __webpack_public_path__ + "static/media/header_illustration.b9b79ca9.png";